export default "__VITE_ASSET__C5Aw8eEz__"